import React, { useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';

import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setIsSubmit, setDeliveryAddress, reportDWH } from '../saleJetBlockSlice';
import ShippingAddress from '../Partials/ShippingAddress/ShippingAddress';
import { getDeliveryTimeSlots, getTechnicianTimesAsync } from '../saleBlockAsyncThunk';
import { gtag4 } from '../../../../utilities/analytics/tracking';

const DeliveryAddressPage = (props) => {

  useEffect(() => {
    if(props.saleType == 'cellular'){
      props.reportDWH({ actionType: 'Delievery Page', status: 'Ongoing', messageText: 'Change Adress Page  Displayed ' });
      gtag4({
        event: 'cellular_Step11_DeliveryAddressPage',
        step: '11',
        action: 'DeliveryAddressPage',
        funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`,
      });
    }
    else{
      props.reportDWH({ actionType: 'Delivery Address', status: 'Ongoing', messageText: 'Delivery Address Page Displayed' });
    }
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  const toggleLinkStyle = { color: "var(--theme-primary, #9631ff)", fontSize: '16px', textAlign: 'center', textDecoration: 'underline', display: 'block', marginTop: '14px' };
  const showOnlyAddressForm = props.saleType == 'cellular';
  let title = props.saleType == 'cellular' ? "לאן תרצה שהשליח יגיע?" : "לאן השליח צריך להגיע?";
  let subTitle = props.saleType == 'cellular' ? 'כתבו לנו את הכתובת שאליה תרצו שנשלח את ה-SIM' : '';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'>{title}</h1>
      <h2 className='sale-title-small'>{subTitle}</h2>
    </div>
  );

  let currentPageView = (
    <div>
      <ShippingAddress address={props.selectedAddress} isSubmit={props.isSubmit} onSubmit={handlePageValidate} showOnlyAddressForm={showOnlyAddressForm} />
      {props.saleType != 'cellular' && <a href='#' style={toggleLinkStyle} onClick={() => goToTechnicianPage()}>התחרטתי, רוצה לקבוע טכנאי</a>}
    </div>
  );

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  function handlePageContinueAfterValid() {
    props.reportDWH({ actionType: 'Delivery Address', status: 'Ongoing', messageText: 'Delivery Address Button Clicked' });
    props.getDeliveryTimeSlots();
  }

  function handlePageValidate(deliveryAddress) {
    if(props.saleType == 'cellular'){
      gtag4({
        event: 'cellular_Step11_DeliveryAddressContinueButton',
        step: '11',
        button: btnText,
        action: 'DeliveryAddressContinueButton',
        funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`,
      });
    }
    props.setIsSubmit(false);
    if (deliveryAddress.isValid) {
      props.setDeliveryAddress(deliveryAddress.selectedAddress);
      handlePageContinueAfterValid();
    }
  }

  function goToTechnicianPage() {
    props.getTechnicianTimesAsync();
  }

  function handlePageContinue() {
    props.setIsSubmit(true);
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    selectedAddress: state.saleJetBlock.addressPage.selectedAddress,
    selectedUserAddress: state.saleJetBlock.userAddressPage.selectedAddress,
    isSubmit: state.saleJetBlock.isSubmit
    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  setIsSubmit,
  setDeliveryAddress,
  getDeliveryTimeSlots,
  getTechnicianTimesAsync,
  reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryAddressPage);
